import { useLocation } from '@tanstack/react-router';
import { useEffect, useSyncExternalStore } from 'react';

import { trackPageView } from '@/lib/analytics';
import { readCookieConsent, subscribeToCookieConsent } from '@/lib/cookie-consent';

export function AnalyticsPageView() {
  const { pathname } = useLocation();
  const consent = useSyncExternalStore(subscribeToCookieConsent, readCookieConsent, () => null);

  useEffect(() => {
    if (consent === 'accepted') trackPageView(pathname, document.title);
  }, [consent, pathname]);

  return null;
}
